import React, { Component } from 'react';
import moment from 'moment';
import { Card, CardTitle, TextField, SelectField, DatePicker, Switch, Button, SelectionControlGroup } from 'react-md';
import CameraManager from '../../managers/CameraManager';
import AccountService from '../../services/AccountService';

const TYPES = [{ label: "Current Year Number", value: "#" }, { label: "% Over Last Year", value: "%" }];
const IMAGEDATAHEADER = "data:image/jpeg;base64,";

export default class ProfileViewManage extends Component {

    constructor(props) {
        super(props);


        this.state = {
            errors: {},
            selectedAvatar: this.props.profileData.avatarType != undefined ? this.props.profileData.avatarType : null,
            imageDataOrURL: this.props.profileData.avatarUrl != undefined ? this.props.profileData.avatarUrl : null,
            tempImage: null,
            inputVals: {
                firstName: this.props.profileData.firstName,
                lastName: this.props.profileData.lastName,
                nickName: this.props.profileData.nickName,
                email: this.props.profileData.email,
                phoneNumber: this.props.profileData.phoneNumber,
                facebookId: this.props.profileData.facebookId,
                facebookPicUrl: this.props.profileData.facebookPicUrl,
                instagramId: this.props.profileData.instagramId,
                instagramPicUrl: this.props.profileData.instagramPicUrl,
                googleId: this.props.profileData.googleId,
                googlePicUrl: this.props.profileData.googlePicUrl,
            },
            imageDidError: false
        }

        this.accountService = new AccountService();

        this.imageCheckStatus = 0;

        this.handleScroll = this.handleScroll.bind(this);

        this.handleImageError = this.handleImageError.bind(this);

        this.checkEmail = this.checkEmail.bind(this);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleLinkZeeZorAccount = this.handleLinkZeeZorAccount.bind(this);
        this.handleLinkFacebookAccount = this.handleLinkFacebookAccount.bind(this);
        this.handleLinkGoogleAccount = this.handleLinkGoogleAccount.bind(this);
        this.handleLinkInstagramAccount = this.handleLinkInstagramAccount.bind(this);
        this.handleChangeAvatar = this.handleChangeAvatar.bind(this);
        this.openCamera = this.openCamera.bind(this);
        this.generateImageSelections = this.generateImageSelections.bind(this);

        this.cameraManager = new CameraManager();
        //UserId,
        //ClientAccountId,
        //status (word) - Read Only
        //LoginId/Username - Read Only
        //FirstName
        //LastName
        //NickName
        //eMail
        //Phone
        //CurrentPassword
        //NewPassword
        //ConfirmPassword
        //Location / Link Link Location
    }

    handleScroll(e) {
        this.props.handleScrollTop(e.target.scrollTop <= 0, e.target.scrollTop);
    }

    handleImageError() {
        if (!this.state.imageDidError) {
            this.setState({ imageDidError: true })
        }
    }

    checkEmail(email) {
        return (email != "" &&
            email.match(/^([a-zA-Z0-9_]+[\.\+])*[a-zA-Z0-9_]+@([a-zA-Z0-9]+\.)*[a-zA-Z0-9]+\.[a-zA-Z]+$/) == null)
    }

    checkAllErrors() {
        var keys = Object.keys(this.state.inputVals)
        let hasErrors = false;
        let errors = {};
        _.each(keys, (key) => {
            errors[key] = this.checkErrors(key, this.state.inputVals[key]);
            if (errors[key] != undefined) {
                hasErrors = true;
            }
        });

        if (hasErrors)
            this.setState({ errors: errors });
        return hasErrors;
    }

    checkErrors(property, value) {
        var error = undefined;
        var requiredProps = ["firstName", "lastName", "email"];

        if (property === 'email') {
            if (this.checkEmail(value)) {
                error = "Invalid email"
            }
        }

        if (property === 'phoneNumber') {
            if (value.length > 0 && value.match(/^[0-9.-]{10,}$/) === null) {
                error = 'Invalid phone'
            }
        }

        if (requiredProps.includes(property)) {
            if (value === null || value === undefined || value.toString().trim() === "" || value === "00000000-0000-0000-0000-000000000000") {
                error = "This field is required.";
            }
        }

        return error;
    }

    handleInputChange(property, value, e) {

        let inputVals = this.state.inputVals;
        inputVals[property] = value;

        let errors = this.state.errors;
        errors[property] = this.checkErrors(property, value);

        this.setState({ errors: errors, inputVals: inputVals });
    }

    openCamera() {
        let self = this;
        this.cameraManager.openCamera((imageData) => {
            self.setState({ imageDataOrURL: IMAGEDATAHEADER + imageData, tempImage: imageData });
        });
    }

    handleSave() {

        if (!this.checkAllErrors()) {

            let sendUrl = this.state.imageDataOrURL;
            if (this.state.tempImage != null) {
                sendUrl = window.__globalConfig.baseUrl + "/api/Account/Avatar/" + this.props.profileData.userId;
            }

            this.props.saveProfile(this.state.inputVals, this.state.selectedAvatar, sendUrl, this.state.tempImage);
        }
    }

    handleLinkZeeZorAccount() {

    }

    handleLinkFacebookAccount() {
        this.props.loadingOn();
        var self = this;

        if (window.ZeeZorRunningOnDevice) {

            CordovaFacebook.login({
                permissions: ['email', 'public_profile'],
                onSuccess: function (res) {
                    let inputVals = self.state.inputVals;
                    inputVals.facebookId = inputVals.facebookId === null ? res.userID : null;
                    inputVals.facebookPicUrl = inputVals.facebookId != null ? "https://graph.facebook.com/v2.12/" + res.userID + "/picture?type=large" : null;
                    self.setState({ inputVals: inputVals, selectedAvatar: self.state.selectedAvatar === 'Facebook' ? 'Insights' : self.state.selectedAvatar }, () => {
                        self.props.linkSocialProfile(self.state.inputVals, "Facebook");
                    });
                },
                onFailure: function (err) {
                    self.props.loadingOff();
                    if (err.cancelled) {

                    } else if (err.error) {

                    }
                }
            });


        } else {

            FB.login(function (res) {
                if (!res.authResponse) {
                    self.props.loadingOff();
                    return;
                }
                let inputVals = self.state.inputVals;
                inputVals.facebookId = inputVals.facebookId === null ? res.authResponse.userID : null;
                inputVals.facebookPicUrl = inputVals.facebookId != null ? "https://graph.facebook.com/v2.12/" + res.authResponse.userID + "/picture?type=large" : null;
                self.setState({ inputVals: inputVals, selectedAvatar: self.state.selectedAvatar === 'Facebook' && inputVals.facebookId === null ? 'Insights' : self.state.selectedAvatar }, () => {
                    self.props.linkSocialProfile(self.state.inputVals, "Facebook");
                });

            }, {
                scope: 'email,public_profile'
            });
        }
    }

    handleLinkInstagramAccount() {


        alert("Instagram linking is coming soon!");

        return;
    }

    handleLinkGoogleAccount() {
        this.props.loadingOn();
        var self = this;

        if (window.ZeeZorRunningOnDevice) {
            window.plugins.googleplus.login(
                {
                    'webClientId': '188952832886-5ge9kagr4r1cgcm9ep65fr76780f5upp.apps.googleusercontent.com'
                },
                function (res) {

                    let inputVals = self.state.inputVals;
                    inputVals.googleId = inputVals.googleId === null ? res.userId : null;
                    inputVals.googlePicUrl = inputVals.googleId != null ? res.imageUrl : null;
                    self.setState({ inputVals: inputVals, selectedAvatar: self.state.selectedAvatar === 'Google' ? 'Insights' : self.state.selectedAvatar }, () => {
                        self.props.linkSocialProfile(self.state.inputVals, "Google");
                    });
                },
                function (err) {
                    self.props.loadingOff();
                }
            );
        } else {
            GoogleAuth.signIn().then(function (res) {

                let inputVals = self.state.inputVals;
                inputVals.googleId = inputVals.googleId === null ? res.getId() : null;
                inputVals.googlePicUrl = inputVals.googleId != null ? res.getBasicProfile().getImageUrl() : null;
                self.setState({ inputVals: inputVals, selectedAvatar: self.state.selectedAvatar === 'Google' ? 'Insights' : self.state.selectedAvatar }, () => {
                    self.props.linkSocialProfile(self.state.inputVals, "Google");
                });
            }, function (err) {

                self.props.loadingOff();
            });
        }
    }

    handleChangeAvatar(val) {
        let imageDataOrURL = "";
        let tempImage = this.state.tempImage;
        this.imageCheckStatus = 0;

        if (this.state.imageDataOrURL != null && this.state.imageDataOrURL.startsWith("data")) {
            tempImage = this.state.imageDataOrURL;
        }

        if (val == "Google") {
            if (this.props.profileData.googlePicUrl !== null)
                imageDataOrURL = null;//this.props.profileData.googlePicUrl;
        }
        else if (val == "Facebook") {
            if (this.props.profileData.facebookPicUrl !== null)
                imageDataOrURL = null;// this.props.profileData.facebookPicUrl;

        }
        else if (val == "Instagram") {
            if (this.props.profileData.instagramPicUrl !== null)
                imageDataOrURL = null;//this.props.profileData.instagramPicUrl;
        }
        else {
            imageDataOrURL = window.__globalConfig.baseUrl + "/api/Account/Avatar/" + this.props.profileData.userId;
        }

        this.setState({ imageDataOrURL: imageDataOrURL, selectedAvatar: val });
    }

    generateImageSelections() {
        var accountTypeRbtList = [];
        // accountTypeRbtList.push({ name: 'ZeeZor', active: this.props.profileData.useZeeZorAccount });
        accountTypeRbtList.push({ name: 'Insights', active: true });
        accountTypeRbtList.push({ name: 'Facebook', active: false });//this.props.profileData.facebookId != null && this.props.profileData.facebookId != '' })
        accountTypeRbtList.push({ name: 'Instagram', active: false });//active: this.props.profileData.instagramId != null && this.props.profileData.instagramId != '' })
        accountTypeRbtList.push({ name: 'Google', active: false });//active: this.props.profileData.googleId != null && this.props.profileData.googleId != '' });

        let buttonList = []
        for (var i = 0; i < accountTypeRbtList.length; i++) {

            let buttonClass = 'profile-image-selection-button';
            if (this.state.selectedAvatar === accountTypeRbtList[i].name && accountTypeRbtList[i].active) {
                buttonClass += ' profile-image-selection-button-active';
            } else if (!accountTypeRbtList[i].active) {
                buttonClass += ' profile-image-selection-button-inactive';
            }

            buttonList.push((
                <div className={buttonClass} onClick={this.handleChangeAvatar.bind(null, accountTypeRbtList[i].name)}>
                    {accountTypeRbtList[i].name}
                </div>
            ));
        }

        return (
            <div className="profile-image-selection-button-container">
                {buttonList}
            </div>
        );
    }

    render() {

        let profile = this.props.profileData;

        let takePhotoClass = this.state.selectedAvatar != "Insights" && this.state.selectedAvatar != "ZeeZor" ? 'take-photo-button take-photo-button--hidden' : 'take-photo-button';

        if (this.props.clientAccount != undefined) {
            let locationsMap = _.map(this.props.clientAccount.locations, (obj) => {
                return {
                    label: obj.name,
                    value: obj.locationID
                };
            });

            locationsMap.unshift({
                label: "Select a Location",
                value: "00000000-0000-0000-0000-000000000000"
            });
        }

        var accountTypeRbtList = [];
        if (this.props.profileData.useZeeZorAccount) {
            accountTypeRbtList.push({ label: 'Insights', value: 'Insights' })
        }

        if (this.props.profileData.googleId) {
            accountTypeRbtList.push({ label: 'Google', value: 'Google' })
        }

        if (this.props.profileData.facebookId) {
            accountTypeRbtList.push({ label: 'Facebook', value: 'Facebook' })
        }

        if (this.props.profileData.instagramId) {
            accountTypeRbtList.push({ label: 'Instagram', value: 'Instagram' })
        }

        let linkedFacebookStyle = profile.facebookId != undefined && profile.facebookId != null && profile.facebookId != '' ? { fill: '#555' } : { fill: '#c4c4c4' }
        let linkedInstaStyle = profile.instagramId != undefined && profile.instagramId != null && profile.instagramId != '' ? { fill: '#555' } : { fill: '#c4c4c4' }
        let linkedGoogleStyle = profile.googleId != undefined && profile.googleId != null && profile.googleId != '' ? { fill: '#555' } : { fill: '#c4c4c4' }

        let profileImage = this.state.imageDataOrURL != undefined && this.state.imageDataOrURL != null && this.state.imageDataOrURL != '' ?
            (<img className="profile-image" onError={this.handleImageError} alt={""} src={this.state.imageDataOrURL} />)
            :
            (<div className="material-icons profile-image-none">person</div>);

        if (this.state.tempImage != undefined && this.state.tempImage != null && this.state.tempImage != '' && this.state.selectedAvatar === 'Insights') {
            profileImage = <img className="profile-image" onError={this.handleImageError} alt={""} src={IMAGEDATAHEADER + this.state.tempImage} />
        }

        if (this.imageCheckStatus === 0) {
            this.imageCheckStatus = 1;
            if (this.state.imageDataOrURL != null &&
                (this.state.imageDataOrURL.includes(window.__globalConfig.baseUrl) || this.state.imageDataOrURL.includes('https://green.gozeezor.com')) &&
                this.state.imageDidError) {
                this.imageCheckStatus = 2;
                profileImage = (<div className="material-icons profile-image-none">person</div>);
            }
        } else {
            if (this.state.imageDataOrURL != null &&
                (this.state.imageDataOrURL.includes(window.__globalConfig.baseUrl) || this.state.imageDataOrURL.includes('https://green.gozeezor.com')) &&
                this.imageCheckStatus === 2) {
                profileImage = (<div className="material-icons profile-image-none">person</div>);
            }
        }


        let imageSelectionJsx = this.generateImageSelections();

        return (
            <div className="profile-central-outer" onScroll={this.handleScroll} style={this.props.style}>
                <div className="profile-central-regular-card-container">
                    <div className="profile-central-title-container">
                        <div className="profile-central-title">{"User Info - " + profile.userName}</div>
                        <div className="profile-central-subtitle">{"Ensure your user information is accurate and complete"}</div>
                    </div>
                    <div className="profile-view-manage-outer">

                        <div className="profile-image-container">
                            {profileImage}
                            <div className={takePhotoClass} onClick={this.openCamera}>{'TAKE PHOTO'}</div>
                        </div>
                        {imageSelectionJsx}
                        <TextField
                            id="first-name-text-field"
                            label="First Name"
                            lineDirection="center"
                            placeholder=""
                            value={this.state.inputVals.firstName}
                            className="profile-field"
                            onChange={this.handleInputChange.bind(null, "firstName")}
                            error={this.state.errors["firstName"] != undefined}
                            errorText={this.state.errors["firstName"]}
                        />
                        <TextField
                            id="last-name-text-field"
                            label="Last Name"
                            lineDirection="center"
                            placeholder=""
                            value={this.state.inputVals.lastName}
                            className="profile-field"
                            onChange={this.handleInputChange.bind(null, "lastName")}
                            error={this.state.errors["lastName"] != undefined}
                            errorText={this.state.errors["lastName"]}
                        />

                        <TextField
                            id="nick-name-text-field"
                            label="Nick Name"
                            lineDirection="center"
                            placeholder=""
                            value={this.state.inputVals.nickName}
                            className="profile-field"
                            onChange={this.handleInputChange.bind(null, "nickName")}
                            error={this.state.errors["nickName"] != undefined}
                            errorText={this.state.errors["nickName"]}
                        />

                        <TextField
                            id="email-text-field"
                            label="Email"
                            lineDirection="center"
                            placeholder=""
                            value={this.state.inputVals.email}
                            className="profile-field"
                            onChange={this.handleInputChange.bind(null, "email")}
                            error={this.state.errors["email"] != undefined}
                            errorText={this.state.errors["email"]}
                        />
                        <TextField
                            id="phone-number-text-field"
                            label="Phone Number"
                            lineDirection="center"
                            placeholder=""
                            value={this.state.inputVals.phoneNumber}
                            className="profile-field"
                            onChange={this.handleInputChange.bind(null, "phoneNumber")}
                            error={this.state.errors["phoneNumber"] != undefined}
                            errorText={this.state.errors["phoneNumber"]}
                        />

                        <div className="profile-bottom-buttons" >
                            <Button flat onClick={this.handleSave}>Save</Button>
                        </div>
                    </div>
                </div>
                <div className="spacer-1"></div>
            </div>
        );
    }
}